import { IUser } from "../../models/interfaces"

export const initialUser: IUser = {
    id: '',
    username: '',
    token: '',
    isAuth: false,
    isAdmin: false,
    isActive: true,    
    dateIn: "",
}